import PluginService from 'services/PluginService';
import { splitActionFieldKey } from '@kizenapps/engine/util';

const tripleKey = (api: string, objectId: string, includeInMenu: boolean) =>
  `${api}::${objectId}::${includeInMenu ? '1' : '0'}`;

export const performAssociationLink = async (
  pluginApiName: string,
  actionsToLink: Record<string, any>,
  templateAssociations: Array<any> = []
) => {
  const actionsToLinkArray: Array<{
    template_api_name: string;
    object_id: string;
    include_perform_action: boolean;
  }> = [];

  for (const actionStateKey in actionsToLink) {
    const actionAPIName = splitActionFieldKey(actionStateKey);

    const state = actionsToLink[actionStateKey];

    if (!state?.value) {
      continue;
    }

    const menuFlags: Record<string, boolean> = state.menuFlags ?? {};

    state.value.forEach((association: any) => {
      actionsToLinkArray.push({
        template_api_name: actionAPIName,
        object_id: association.id,
        include_perform_action: Boolean(menuFlags[association.id]),
      });
    });
  }

  const desiredKeys = new Set(
    actionsToLinkArray.map((item) =>
      tripleKey(
        item.template_api_name,
        item.object_id,
        item.include_perform_action
      )
    )
  );

  const existingKeys = new Set(
    templateAssociations.map((association) =>
      tripleKey(
        association.browser_js_action_template?.api_name || '',
        association.custom_object?.id || '',
        Boolean(association.include_perform_action)
      )
    )
  );

  const actionsToDelete = templateAssociations.filter((association) => {
    const key = tripleKey(
      association.browser_js_action_template?.api_name || '',
      association.custom_object?.id || '',
      Boolean(association.include_perform_action)
    );
    return !desiredKeys.has(key);
  });

  const actionsToAdd = actionsToLinkArray.filter((item) => {
    const key = tripleKey(
      item.template_api_name,
      item.object_id,
      item.include_perform_action
    );
    return !existingKeys.has(key);
  });

  // Delete before add: if a (template, object) pair is changing its
  // include_perform_action flag, both lists contain the same pair, and the
  // backend may enforce uniqueness on (template, object).
  await Promise.all(
    actionsToDelete.map((association) =>
      PluginService.deleteTemplateAssociation(association.id)
    )
  );

  await Promise.all(
    actionsToAdd.map((item) =>
      PluginService.createTemplateAssociation(
        item.template_api_name,
        pluginApiName,
        item.object_id,
        item.include_perform_action
      )
    )
  );
};
